
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Building } from 'lucide-react';

interface EmptySearchResultsProps {
  searchTerm: string;
  onClearSearch: () => void;
}

const EmptySearchResults = ({ searchTerm, onClearSearch }: EmptySearchResultsProps) => {
  return (
    <div className="text-center py-16 animate-fade-in">
      <div>
        <h3 className="text-xl font-medium text-redflags-dark mb-2">No matching companies</h3>
        <p className="text-redflags-gray mb-6">
          Can't find the company you're looking for? Request to add it to our database.
        </p>
        <div className="flex flex-col items-center space-y-4">
          <div className="w-16 h-16 bg-redflags-light/20 rounded-full flex items-center justify-center mb-2">
            <Building className="w-8 h-8 text-redflags-red" />
          </div>
          <Button 
            asChild
            className="bg-redflags-red hover:bg-redflags-red/90 text-white"
          >
            <Link to="/request-company">
              Request New Company
            </Link>
          </Button>
          <Button 
            variant="outline" 
            onClick={onClearSearch}
            className="border-redflags-gray text-redflags-gray hover:bg-redflags-gray/5"
          >
            Show all companies
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmptySearchResults;
